import React, { useRef, useState } from 'react';
import Header from '../../../common/Header/Header';
import { connect } from 'react-redux';
import ErrorAlert from "../../../common/Alert/ErrorAlert";
import SuccessAlert from "../../../common/Alert/SuccessAlert";

const CreateFreeCourse = ({ csrf, islogin }) => {
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false); 

    const [iserror,setIsError] = useState(false);
    const [issuccess,setIsSuccess] = useState(false);
    const [message,setMessage] = useState("");
    const [errorList, setErrorList] = useState([]);

    const resetFormFields = () => {
        fileInputRef.current.value = '';
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return; 
        setErrorList([]);

        const file = fileInputRef.current.files[0];
        if (!file || file.type !== "application/json") {
            setIsError(true);
            setMessage("Please upload a valid JSON file.");
            setTimeout(() => {
                setIsError(false);
                setMessage("");
            }, 3000);
            resetFormFields();
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append("platform", 'freecourses');
        formData.append("file", file);
        formData.append("url", 'courses/validation/');
        formData.append("forward_user_data", "True");
        formData.append("timeout", 100);

        fetch(process.env.REACT_APP_ELEVATE_USER_REST_URL, {
            method: 'POST',
            body: formData,
            headers: {
                "X-CSRFToken": csrf,
            },
            credentials: process.env.REACT_APP_CREDENTIAL_TYPE
        })
        .then((response) => {
            if (!response.ok) {
                setIsError(true);
                setMessage("Network response was not ok!");
                setTimeout(() => {
                    setIsError(false);
                    setMessage("");
                }, 3000);
                resetFormFields();
                setLoading(false); 
                return false;
            }
            return response.json();
        })
        .then(result => {
            if (result && result?.response?.status_code === 200 && result?.response?.status) {
                setIsSuccess(true);
                setMessage(`Free Course has been ${result?.response?.status} successfully!`);
                setTimeout(() => {
                    setIsSuccess(false);
                    setMessage("");
                }, 3000);
                resetFormFields();
            }
            else {
                setIsError(true);
                let errorMsg = result?.response?.error || "Something went wrong.";
                setMessage("Some required fields are missing.");
                const list = errorMsg.split('\n').filter(line => line.trim() !== '');
                setErrorList(list);
                setTimeout(() => {
                    setIsError(false);
                    setMessage("");
                }, 3000);
                resetFormFields();
            }
            setLoading(false);
        })
        .catch(error => {
            console.log("here", error);
            setIsError(true);
            setMessage(error.message);
            setTimeout(() => {
                setIsError(false);
                setMessage("");
            }, 3000);
            console.log(error);
            setLoading(false);
        });
    }

    return (
        <>
            <Header />
            {iserror && <ErrorAlert message={message} setIsError={setIsError} />}
            {issuccess && <SuccessAlert message={message} setIsSuccess={setIsSuccess} />}
            <section id='createFreeCourse' className='common-style background-dark-primary min-vh-100'>
                <div className='container py-4 px-5'>
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-lg-10'>
                            <div className='card p-4 border-0 shadow background-dark-tertiary'>
                                <div className="card-body">
                                    <h3 className="card-title mb-3 text-center text-white fw-semibold text-uppercase">Free Course Creation</h3>
                                    <form className='w-100' onSubmit={handleSubmit}>
                                        <div className="form-group my-5">
                                            <label htmlFor="jsonFile" className="me-3 text-white">JSON File: <sup className='text-danger'>*</sup></label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="jsonFile"
                                                ref={fileInputRef}
                                                required
                                            />
                                        </div>
                                        <button type="submit" disabled={loading} className='btn btn-dark btn-dark-primary px-5 py-2 mt-3 text-uppercase fw-bold w-100'>
                                            {loading ? 'Creating...' : 'Create Course Using JSON File'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {errorList.length > 0 && (
                <div className="container px-5 pt-4 pb-5">
                     <div className='row d-flex justify-content-center align-items-center'>
                        <div className='col-lg-10'>
                            <div className="card p-4 border-0 shadow background-dark-tertiary">
                                <div className='card-body'>
                                    <h5 className="card-title mb-3 text-center text-white fw-semibold text-uppercase">Error List</h5>
                                    <ul className="mb-0">
                                        {errorList.map((err, idx) => (
                                            <li key={idx} className="text-white">{err}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            )}
            </section>
        </>
    )
}

const mapStateToProps = (state) => ({
    csrf: state.LoginModalReducer.csrf,
    islogin: state.LoginModalReducer.islogin
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateFreeCourse);